import type { RuleSetting } from './api.ts'

/**
 * The on/off state of an account's rules while somebody is editing it.
 *
 * Held as the ids switched *off*, because that is what the server stores and
 * what `disabledRules` sends back: a rule nobody mentions is on.
 */

/** The rules the server says are off. */
export function disabledIds(rules: readonly RuleSetting[]): string[] {
  return rules.filter((rule) => !rule.enabled).map((rule) => rule.id)
}

/** `disabled` with one rule switched on or off. */
export function withRuleToggled(disabled: readonly string[], id: string, on: boolean): string[] {
  const others = disabled.filter((one) => one !== id)
  return on ? others : [...others, id]
}

/** Whether the edit differs from what is saved, whatever order it was made in. */
export function togglesChanged(
  rules: readonly RuleSetting[],
  disabled: readonly string[],
): boolean {
  const saved = disabledIds(rules)
  return saved.length !== disabled.length || saved.some((id) => !disabled.includes(id))
}
